import { useEffect, useRef, useState } from "react";
import { toast } from "sonner";
import { fileUrl } from "../lib/api";
import { CardFront, CardBack, newCardPDF, addCardSheet, SHEET } from "./RiderCard";

const BATCH = SHEET;
const sleep = (ms) => new Promise((r) => setTimeout(r, ms));
const ready = async (root, n) => {
  for (let t = 0; t < 80; t++) {
    const imgs = [...root.querySelectorAll("img")];
    if (root.querySelectorAll("[data-testid=rider-card-qr]").length >= n && imgs.every((im) => im.complete)) return;
    await sleep(100);
  }
};

// Renders cards offscreen in batches and saves one A4 PDF (9 fronts per page, then mirrored backs page).
export const BulkCardsPDF = ({ cards, cfg, onProgress, onDone }) => {
  const [start, setStart] = useState(0);
  const root = useRef(null), pdf = useRef(null);
  const batch = cards.slice(start, start + BATCH);
  useEffect(() => {
    let dead = false;
    (async () => {
      try {
        await ready(root.current, batch.length);
        if (dead) return;
        if (!pdf.current) pdf.current = newCardPDF();
        const els = [...root.current.querySelectorAll("[data-side]")];
        await addCardSheet(pdf.current, batch.map((_, i) => [els[2 * i], els[2 * i + 1]]));
        const done = Math.min(start + BATCH, cards.length);
        onProgress?.(done);
        if (done < cards.length) setStart(done);
        else { pdf.current.save(`بطاقات-المناديب-${new Date().toISOString().slice(0, 10)}.pdf`); toast.success(`تم إنشاء ملف ${cards.length} بطاقة`); onDone(true); }
      } catch { toast.error("تعذّر إنشاء ملف الطباعة"); onDone(false); }
    })();
    return () => { dead = true; };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [start]);
  const logo = cfg.logo_id ? fileUrl(cfg.logo_id) : null;
  return (
    <div ref={root} aria-hidden style={{ position: "fixed", left: -10000, top: 0, pointerEvents: "none" }}>
      {batch.map((c) => (
        <div key={c.id || c.token} style={{ display: "flex", gap: 10, marginBottom: 10 }}>
          <div data-side><CardFront card={c} cfg={cfg} urlOf={fileUrl} flat photoUrl={c.photo_id ? fileUrl(c.photo_id) : null} /></div>
          <div data-side><CardBack cfg={cfg} brand={c.brand} urlOf={fileUrl} flat token={c.token} logoUrl={logo} /></div>
        </div>
      ))}
    </div>
  );
};
